import { useMemo } from "react"
import { type TMultiSelectOption } from "~/ui-rtk/components/ui/controls/MultiSelect"
import useCampaignOptions from "./useCampaignOptions"

export function useSelectFilterOptions() {
  const { campaignOptions, isLoading: campaignLoading } = useCampaignOptions()

  const getSelectOptions = useMemo(
    () =>
      (columnKey: string): TMultiSelectOption[] => {
        switch (columnKey) {
          case "campaign_id":
            return campaignOptions
          case "campaign_name":
            return campaignOptions

          // Add more column types here as needed
          // case "adset_id":
          //   return adsetOptions
          // case "media_channel":
          //   return mediaChannelOptions

          default:
            return []
        }
      },
    [campaignOptions],
  )

  return {
    getSelectOptions,
    isLoading: campaignLoading, // Add other loading states as needed
  }
}

export default useSelectFilterOptions
